<template>
	<div :class="`flex items-center justify-center ${big ? 'w-32 h-32' : 'w-16 h-16'} rounded-full`">
		<div
			:class="
				`flex items-center justify-center bg-white rounded-full ${big ? 'w-24' : 'w-12'} ${
					big ? 'h-24' : 'h-12'
				}`
			"
		>
			<div class="relative">
				<svg class="timer-svg" :width="`${big ? '108' : '54'}`" :height="`${big ? '108' : '54'}`">
					<circle
						:class="`${big ? 'timer-back-bg-big' : 'timer-back-bg'}`"
						:cx="`${big ? '54' : '27'}`"
						:cy="`${big ? '54' : '27'}`"
						:r="`${big ? '48' : '24'}`"
					></circle>
					<circle
						v-if="big"
						class="timer-progress-big"
						cx="54"
						cy="54"
						r="48"
						stroke-linecap="round"
					></circle>
					<circle v-else class="timer-progress" cx="27" cy="27" r="24" stroke-linecap="round"></circle>
				</svg>
				<div class="timer-text">
					<span :class="`${big ? 'text-39' : 'text-18'} font-bold leading-none`"
						>{{ remainingMinutes.value }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';

	export default {
		name: 'CountdownTimer',
		props: {
			acceptedTime: {
				type: String,
				required: true,
			},
			readyTime: {
				type: Number,
				required: true,
			},
			big: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				totalSeconds: this.calculateTotalSeconds(),
				maxDrawnLength: this.big ? 302 : 151,
				fixedGap: 0,
			};
		},
		computed: {
			remainingMinutes() {
				if (this.totalSeconds > 0 && this.totalSeconds < 60) {
					return { value: this.totalSeconds };
				} else if (this.totalSeconds < 0) {
					return { value: `+${Math.abs(Math.floor(this.totalSeconds / 60))}` };
				}
				return { value: Math.floor(this.totalSeconds / 60) };
			},
			progressColor() {
				const oneHalf = this.readyTime * 60 * (1 / 2);
				if (this.totalSeconds <= 0) {
					return '#dc3545';
				} else if (this.totalSeconds <= oneHalf) {
					return '#ffc107';
				} else {
					return '#28a745';
				}
			},
		},
		methods: {
			calculateTotalSeconds() {
				const acceptedDate = moment(this.acceptedTime);
				const now = moment();
				if (acceptedDate.isAfter(now)) {
					this.maxDrawnLength = 115;
					return this.readyTime * 60;
				}
				const readyDate = acceptedDate.add(this.readyTime, 'minutes');
				return Math.floor(readyDate.diff(now, 'seconds'));
			},
			updateTimer() {
				this.totalSeconds--;
				this.updateProgressCircle();
			},
			updateProgressCircle() {
				const progressCircle = this.big
					? this.$el.querySelector('.timer-progress-big')
					: this.$el.querySelector('.timer-progress');
				if (progressCircle) {
					let remainingDrawnLength;
					if (this.totalSeconds <= 0) {
						remainingDrawnLength = this.maxDrawnLength;
					} else {
						remainingDrawnLength = (this.totalSeconds / (this.readyTime * 60)) * this.maxDrawnLength;
					}
					const gapLength = this.maxDrawnLength + this.fixedGap - remainingDrawnLength;
					progressCircle.style.strokeDasharray = `${remainingDrawnLength} ${gapLength}`;
					progressCircle.style.stroke = this.progressColor;
				}
			},
		},
		mounted() {
			this.updateTimer();
			this.timerInterval = setInterval(this.updateTimer, 1000);
		},
		beforeUnmount() {
			clearInterval(this.timerInterval);
		},
	};
</script>
<style scoped>
	.timer-svg {
		transform: rotate(-90deg); /* Start from the top */
	}
	.timer-back-bg {
		fill: none;
		stroke: #edf2f7;
		stroke-width: 4;
		stroke-dasharray: 151 0; /* Full circle (2 * π * r, where r = 24) */
		stroke-dashoffset: 0;
		transition: stroke-dasharray 1s linear;
	}
	.timer-back-bg-big {
		fill: none;
		stroke: #edf2f7;
		stroke-width: 8;
		stroke-dasharray: 302 0; /* Full circle (2 * π * r, where r = 48) */
		stroke-dashoffset: 0;
		transition: stroke-dasharray 1s linear;
	}
	.timer-progress {
		fill: none;
		stroke: #28a745;
		stroke-width: 4;
		stroke-dasharray: 151 0; /* Full circle */
		stroke-dashoffset: 0;
		transition: stroke-dasharray 1s linear;
	}
	.timer-progress-big {
		fill: none;
		stroke: #28a745;
		stroke-width: 8;
		stroke-dasharray: 302 0; /* Full circle */
		stroke-dashoffset: 0;
		transition: stroke-dasharray 1s linear;
	}
	.timer-text {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: #333;
	}
</style>
